import { ReadOnlyQuill } from 'components/WYSIWYG/ReadOnlyQuill';
import { isEmptyWysiwygHtml } from 'components/WYSIWYG/wysiwyg.utils';
import { useSiteGuidelinesPlacement } from 'hooks/site/useSiteGuidelinesPlacement';
import { useGuidelinesTemplate } from 'query/storage';
import { isGuidelinesAboveSlots } from 'utils/siteUtils';

import { PatientBookingGuidelinesAboveSlotsStyled } from './PatientBooking.styled';

export const PatientBookingGuidelinesAboveSlots = () => {
  const placement = useSiteGuidelinesPlacement();
  const { data } = useGuidelinesTemplate();
  const guidelines = data?.data;

  if (!isGuidelinesAboveSlots(placement) || isEmptyWysiwygHtml(guidelines)) {
    return null;
  }

  return (
    <PatientBookingGuidelinesAboveSlotsStyled>
      <ReadOnlyQuill value={guidelines} />
    </PatientBookingGuidelinesAboveSlotsStyled>
  );
};
